import { render } from "./footerAll.vue?vue&type=template&id=7b488708&scoped=true"
import script from "./footerAll.vue?vue&type=script&lang=js"
export * from "./footerAll.vue?vue&type=script&lang=js"

import "./footerAll.vue?vue&type=style&index=0&id=7b488708&lang=less&scoped=true"

import exportComponent from "E:\\永福丽项目\\永富丽官网Vue3\\app_winfully_cn\\app_qy_vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b488708"]])

export default __exports__